 import React, { Fragment, useState } from 'react';
import Close from '../../../../../Assets/Modals/closeIcon.svg';
import ChevronDown from '../../../../../Assets/Modals/ChevronDown.svg';
import { closeModal } from '../../../../../Features/dropTrackProductsSlice';
import { useDispatch } from 'react-redux';
import { showToast } from '../../../../../Components/Toaster/Toaster';

function SelectCouponType({ selectCouponType }) {
    const dispatch = useDispatch();
    const [dropdownSelection, setDropdownSelection] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const handleCloseButtonClick = () => {
        dispatch(closeModal());
    };

    const handleDropdownSelection = (selection) => {
        setDropdownSelection(selection);
        setIsOpen(false);
    }

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }

    const handleNextClick = () => {
        if(dropdownSelection) {
            selectCouponType(dropdownSelection);
        }
        else {
            showToast('Select Coupon type before proceeding', 'warning');
        }
    }

    return (
        <Fragment>
            <div className="flex items-center justify-between">
                <h1 className='font-urbanist-regular font-semibold text-2xl text-[#121212]'>Select Coupon Type</h1>

                <button onClick={handleCloseButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <h1 className='mt-[-8px] text-[#666666] font-urbanist-regular font-medium text-[16px] leading-[28px]'>Select the right coupon and its value to craft amazing deals.</h1>

            <div className="flex flex-col gap-2 relative">
                <label className='m-0 font-urbanist-regular font-medium text-base text-[#000000]' htmlFor="name-input">
                    Select Coupon Type
                </label>

                <button onClick={toggleDropdown} className="outline-none h-14 px-3 py-4 bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px] flex items-center justify-between">
                    <p className='text-[#666666] font-urbanist-regular font-normal text-base'>
                        {!dropdownSelection.length ? 'Select' : (dropdownSelection === 'PERCENTAGE_DISCOUNTS' ? 'Percentage Discounts' : 'Fixed Discounts')}
                    </p>

                    <div className="flex items-center justify-center">
                        <img src={ChevronDown} alt="Dropdown" />
                    </div>                    
                </button>

                {isOpen && 
                    <ul className="w-full absolute bottom-14 right-0 border border-[#EAEAEA] shadow-[0px_3px_6px_0px_#0000001F] rounded-xl overflow-hidden">
                        <li className='cursor-pointer px-3 py-4 bg-[#FFFFFF]' onClick={() => handleDropdownSelection('PERCENTAGE_DISCOUNTS')}>Percentage Discounts</li>
                        <li className='cursor-pointer px-3 py-4 bg-[#FFFFFF]' onClick={() => handleDropdownSelection('FIXED_DISCOUNTS')}>Fixed Discounts</li>
                    </ul>
                }
            </div>

            <button onClick={handleNextClick} className='bg-primaryColor hover:bg-primaryAccent px-4 py-2 rounded font-semibold text-base text-center text-buttonText' type='button'>
                Next
            </button>
        </Fragment>
    );
}

export default SelectCouponType;
